import {getApiUrl} from "../utils/util-functions";

export interface NmiSettings {
    enabled: boolean;
    processor: string;
    tokenize_key: string | null;
}

export const getNmiSettings = async (): Promise<NmiSettings | null> => {
    const response = await fetch(`${getApiUrl()}/payment/nmi/settings`);
    const body = await response.json();
    if (!body || body.error) {
        return null;
    }
    return body.response ?? null;
};
